/**
 * State register
 */

export default function () {
	return { 
   		locale: ''
	}
}
